<div class="row mt-3 mb-3">
  <div *ngIf="!somenteVisualizar" class="col-sm-6 d-flex align-items-center">
    <button (click)="adicionar()" [disabled]="disabled()" class="btn btn-sm btn-outline-primary">
      <em class="fa fa-plus"></em>
      Adicionar Item
    </button>
  </div>
  <div *ngIf="!somenteVisualizar" class="col-sm-6 d-flex flex-column justify-content-center align-items-end">
    <span class="text-success">
      <span class="badge badge-success mr-2">Ctrl + I</span> Adicionar novo item
    </span>
    <span class="text-danger">
      <span class="badge badge-danger mr-2">Ctrl + O</span> Cancelar cadastro/alteração do item
    </span>
  </div>
</div>
<table class="table table-eddy table-eddy-sm" style="font-size: 12px" *ngIf="lista && lista.length > 0">
  <thead>
    <tr>
      <th *ngIf="!disabled()" scope="col" style="width: 5%"></th>
      <th scope="col" style="width: 5%;">Ordem</th>
      <th scope="col" style="width: 8%;" class="text-center">Quantidade</th>
      <th scope="col" style="width: 40%;">Item</th>
      <th scope="col" style="width: 9%;" class="text-center">Vl. Unitário</th>
      <th scope="col" style="width: 8%;" class="text-center">Valor Total</th>
      <th scope="col" style="width: 8%;" class="text-center">Desconto</th>
      <th scope="col" style="width: 8%;" class="text-center">ICMS/IPI</th>
      <th scope="col" style="width: 10%;" class="text-center"></th>
    </tr>
  </thead>
  <tbody cdkDropList (cdkDropListDropped)="refazerOrdenacao($event)">
    <tr *ngFor="let item of lista; let idx = index">
      <td *ngIf="!disabled()" class="text-center" cdkDrag style="cursor: move;">
        <em *ngIf="!item.editavel && !somenteVisualizar" class="fa fa-bars" style="font-size: large;"></em>
      </td>
      <td class="text-center">
        {{item.ordem}}
      </td>
      <td *ngIf="!item.editavel" class="text-center">
        {{item.quantidade | number:'1.3-3'}}</td>
      <td *ngIf="!item.editavel">
        <u>{{item.produto_unidade.produto?.codigo}}</u>
        {{funcaoService.abreviarStr(item.produto_unidade.produto?.nome, 80)}} -
        <strong>{{item.produto_unidade.unidade?.nome}}</strong>
      </td>
      <td *ngIf="!item.editavel" class="text-center">
        {{item.valor_unitario | number:'1.5-5'}}</td>
      <td *ngIf="!item.editavel" class="text-center">
        {{(item.valor_unitario * item.quantidade) | number:'1.5-5'}}</td>
      <td *ngIf="!item.editavel" class="text-center">
        {{item.valor_desconto | number:'1.5-5'}}</td>
      <td *ngIf="!item.editavel" class="text-center">
        {{item.valor_icmsipi | number:'1.5-5'}}</td>

      <td *ngIf="item.editavel" class="text-center">
        <input [(ngModel)]="item.quantidade" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="local" [imask]="imaskValor" unmask="typed" #inpQuantidade>
      </td>

      <td *ngIf="item.editavel">
        <p-autoComplete *ngIf="item.editavel" id="rec" [(ngModel)]="item.produto_unidade.produto"
          [forceSelection]="true" [autoHighlight]="true" [ngModelOptions]="{standalone: true}"
          [field]="produtoAutoComplete.conversor" [suggestions]="produtoAutoComplete.lista"
          (completeMethod)="produtoAutoComplete.filtrar($event)" (onSelect)="carregarUnidades(item)"
          inputStyleClass="form-control form-control-sm" minLength="2" [style]="{ width: '85%' }"
          [inputStyle]="{'font-size': '13px'}">
          <ng-template let-produto pTemplate="item">
            {{produto.codigo}} {{produto.nome}}
          </ng-template>
        </p-autoComplete>
        <select *ngIf="item.editavel" [compareWith]="compareFn" id="produto_unidade" [(ngModel)]="item.produto_unidade"
          [ngModelOptions]="{standalone: true}" class="form-control form-control-sm float-right"
          style="width: 15%;font-size: 13px;">
          <option [ngValue]="undefined">---</option>
          <option [ngValue]="item" *ngFor="let item of produtoUnidades">
            {{item.unidade.nome}}
          </option>
        </select>

      </td>
      <td *ngIf="item.editavel" class="text-center">
        <input [(ngModel)]="item.valor_unitario" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="nome" [imask]="imaskValor" unmask="typed">
      </td>
      <td *ngIf="item.editavel" class="text-center">
        {{(+item.valor_unitario * +item.quantidade - (+item.valor_icmsipi - +item.valor_desconto)) | number:'1.5-5'}}
      </td>
      <td *ngIf="item.editavel" class="text-center">
        <input [(ngModel)]="item.valor_desconto" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="cargo" [imask]="imaskValor" unmask="typed">
      </td>
      <td *ngIf="item.editavel" class="text-center">
        <input [(ngModel)]="item.valor_icmsipi" [ngModelOptions]="{standalone: true}" type="text"
          class="form-control form-control-sm" id="cargo" [imask]="imaskValor" unmask="typed">
      </td>
      <td class="text-right">
        <button *ngIf="item.editavel && !somenteVisualizar" (click)="salvar(item)"
          class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel && !somenteVisualizar" (click)="cancelar(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel && !somenteVisualizar" (click)="editar(item)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel && !somenteVisualizar" (click)="remover(item, idx)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
    <tr *ngIf="lista && lista.length > 0" class="font-weight-bold" style="background-color: rgba(7, 173, 250, 0.274); border-top: 2px solid #000;">
      <td *ngIf="!disabled()"></td>
      <td></td>
      <td class="text-center">{{somaItens().quantidade | number:'1.5-5'}}</td>
      <td></td>
      <td class="text-center">{{somaItens().unitario | number:'1.5-5'}}</td>
      <td class="text-center">{{+somaItens().valor_total | number:'1.5-5'}}</td>
      <td class="text-center">{{somaItens().desconto | number:'1.5-5'}}</td>
      <td class="text-center">{{somaItens().icmsipi | number:'1.5-5'}}</td>
      <td></td>
    </tr>
  </tbody>
</table>